<div class="flex flex-col w-full shadow-lg rounded-b-3xl">
  <!-- TOTAL + BANNER -->
  <div class="h-[6rem] flex w-full items-center justify-between bg-primary p-3 px-6">
    <div class="flex items-center">
      <app-svg-viewer
        class="hidden md:block"
        [svg]="svg"
      ></app-svg-viewer>
      <app-svg-viewer
        class="md:hidden"
        [svg]="svg"
        [size]="200"
      ></app-svg-viewer>
    </div>

    <div class="flex flex-col text-white">
      <p class="text-2xl font-bold">
        {{ store.summaryAmount() | currency: '€' : 'symbol' : '1.2-2' : 'fr' }}
      </p>
      <p class="text-end text-sm">
        {{ resource.offerCustomize.suffixCurrency }}
      </p>
    </div>
  </div>
  <div class="flex flex-col w-full py-4 px-4 md:px-[7rem] items-start gap-3 text-sm md:text-base">
    @for (item of store.summary(); track $index) {
      <div class="flex justify-between items-center w-full">
        <p class="text-secondary">{{ item.key }}</p>
        @if (isNumber(item.value)) {
          <p>
            {{ item.value | currency: '€' : 'symbol' : '1.2-2' : 'fr' }}
          </p>
        } @else {
          <p>{{ item.value }}</p>
        }
      </div>
    }
  </div>
</div>
